export default __webpack_public_path__ + "static/media/logo_trqk_iq_blank_edition.50695044.svg";